import { render, staticRenderFns } from "./PDFs.vue?vue&type=template&id=4e5342e2&scoped=true"
import script from "./PDFs.vue?vue&type=script&lang=js"
export * from "./PDFs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5342e2",
  null
  
)

export default component.exports